/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';
import { Log } from '../../../../core/logging/Log';
import { ScreenTaskControllerTypes } from '../../../../core/navigation/ScreenTaskControllerTypes';
import { setScreenTaskController } from '../../../screens/screens.reducers';
import { changeAudioTrack } from '../../videoplayer.reducers';
import { VuLogger } from '../../../../core/logging';
import {
    hideOverlayDialog,
    showOverlayDialog,
} from '../../../overlaydialog/overlaydialog.reducers';
import { IOverlayDialog } from '../../../overlaydialog/overlaydialogprops';
import { Locale } from '../../../../core/locale/Locale';
import { LocaleKeys } from '../../../../core/locale/LocaleKeys';
import { InfoBannerUtils } from '../../../../views/VideoPlayerUI/FullInfoBanner/EventDescription/InfoBannerUtils';
import { OverlayTypes } from '../../../overlay/OverlayTypes';
import { VideoManager } from '../../../../core/videoplayer';

const TAG = 'audiotrackoverlay';

export const showAudioTrackOverlay = () => (dispatch: Function) => {
    const tracks = VideoManager.getInstance().getVideoPlayerModel().getAudioTrackModel();
    const { airingOffers, offerPreview } = VideoManager.getInstance().getMetadata();
    const dataFormatter = new InfoBannerUtils(airingOffers, offerPreview);
    const audioSubtitlePopupTitle = dataFormatter.getAudioSubtitlePopupTitle();
    if (tracks.length > 0) {
        const overlayDialogProps: IOverlayDialog = {
            hasDimmer: false,
            hasSeperator: false,
            options: tracks,
            title: Locale.getString(LocaleKeys.AUDIO_TRACK_OVERLAY_TITLE),
            subtitle: audioSubtitlePopupTitle,
            overlayType: OverlayTypes.AUDIO_TRACK,
        };
        dispatch(showOverlayDialog(overlayDialogProps));
        Diagnostics.debug(
            TAG,
            'showAudioTrackOverlay {screenTaskController: ',
            ScreenTaskControllerTypes.AUDIO_TRACK_OVERLAY,
            '}',
        );
        Log.d(
            TAG,
            'showAudioTrackOverlay {screenTaskController: ',
            ScreenTaskControllerTypes.AUDIO_TRACK_OVERLAY,
            '}',
        );
        dispatch(setScreenTaskController(ScreenTaskControllerTypes.AUDIO_TRACK_OVERLAY));
    }
};

export const onKeyBackAudioTrackOverlay =
    (calledFromOnTrackSelect?: boolean) => (dispatch: Function, getState: Function) => {
        const { isOverlayDialogActive } = getState().overlayDialog;

        if (isOverlayDialogActive) {
            dispatch(hideOverlayDialog());
        }
        Log.d(
            TAG,
            'onKeyBackAudioTrackOverlay {screenTaskController: ',
            ScreenTaskControllerTypes.DEFAULT_VIDEO_PLAYER_TASKS,
            '}',
        );
        Diagnostics.debug(
            TAG,
            'onKeyBackAudioTrackOverlay {screenTaskController: ',
            ScreenTaskControllerTypes.DEFAULT_VIDEO_PLAYER_TASKS,
            '}',
        );

        if (!calledFromOnTrackSelect) {
            VuLogger.logUserActionEvent({
                actionName: VuLogger.UserActionEventActionName.AUDIO_LANGUAGE,
                action: VuLogger.UserActionEventAction.CANCEL,
                screen: VuLogger.UserActionEventScreen.OVERLAYS,
                selection: VideoManager.getInstance()
                    .getVideoPlayerModel()
                    .getCurrentAudioSelectedTrack(),
            });
        }
        dispatch(setScreenTaskController(ScreenTaskControllerTypes.DEFAULT_VIDEO_PLAYER_TASKS));
    };

export const onKeyOkAudioTrackOverlay = () => (dispatch: Function, getState: Function) => {
    const { isOverlayDialogActive } = getState().overlayDialog;
    const { verticalPosition } = getState().overlayHighlight;

    if (isOverlayDialogActive) {
        dispatch(onTrackSelect(verticalPosition));
    }
};

export const onTrackSelect = (selectedIndex: number) => (dispatch: Function) => {
    dispatch(changeAudioTrack(selectedIndex));
    dispatch(onKeyBackAudioTrackOverlay(true));
};
